// Enlace de reservas (Linktree) usado por todos los CTA de "Agendar / Reservar".
export const BOOKING_URL =
  'https://linktr.ee/libelle_estetica?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQPOTM2NjE5NzQzMzkyNDU5AAGnHdGf08uW3El7bsPGeKShhPGXkMJ7RzapN2iaE5VGMm8XPyfB1s_5W6GBVyc_aem_MYTpUjxNgQpqVgvd5nDcFg'
